import React from 'react'

const Footer = () => {
    return (
        <footer id='footer' role='contentinfo'>
            <a href='mailto:yunyoungsik91@gmail.com' rel='noopener noreferrer'>yunyoungsik91@gmail.com</a>
        </footer>
    )
}

export default Footer